import { Box, Divider, Grid, Typography } from "@mui/material";
import React from "react";
import SignBox from "../../../../components/UI/SignerBox";

const ManufactureESignatureFooter = ({ data }) => {
  const defaultSx = { fontSize: 12 };

  const { created_by, created_date } =
    data.employee_activity?.created_data ?? {};

  return (
    <>
      <Box sx={{ display: "flex", gap: 0.75, mt: 2 }}>
        <Typography sx={{ ...defaultSx, fontWeight: 600 }}>
          หมายเหตุภายใน/Internal Remark:
        </Typography>
        <Typography sx={defaultSx}>{data.remark}</Typography>
      </Box>
      <Divider sx={{ mt: 2 }} />
      <Grid container mt={2}>
        <Grid item xs={5.75}>
          <Typography
            sx={{
              ...defaultSx,
              lineHeight: "10px",
              letterSpacing: "0.15px",
              fontWeight: 600,
              color: "#333333",
              flex: 1,
              mb: 2,
            }}
          >
            เบิกสินค้า/วัตถุดิบ
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              flexWrap: "nowrap",
              justifyContent: "center",
            }}
          >
            <SignBox text={"ผู้เบิก"} created_by={null} created_date={null} />
            <SignBox
              text={"ผู้ตรวจ/ฝ่ายบัญชี"}
              created_by={null}
              created_date={null}
            />
            <SignBox
              text={"ผู้อนุมัติ"}
              created_by={null}
              created_date={null}
            />
          </Box>
        </Grid>
        <Grid item xs={0.5} padding="0 15px 0 15px">
          <Divider orientation="vertical" />
        </Grid>
        <Grid item xs={5.75}>
          <Typography
            sx={{
              ...defaultSx,
              lineHeight: "10px",
              letterSpacing: "0.15px",
              fontWeight: 600,
              color: "#333333",
              flex: 1,
              mb: 2,
            }}
          >
            ผลิตสินค้า/วัตถุดิบ
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: "0.5rem",
              flexWrap: "nowrap",
              justifyContent: "center",
            }}
          >
            <SignBox
              text="ผู้จ่ายงาน"
              created_by={created_by}
              created_date={created_date}
              documentType="manufacture_order"
            />
            <SignBox
              text="ผู้ผลิต"
              created_by={null}
              created_date={null}
              documentType="manufacture_order"
            />
            <SignBox
              text="ผู้ตวรจสอบ"
              created_by={created_by}
              created_date={created_date}
              documentType="manufacture_order"
            />
            <SignBox
              text="ผู้อนุมัติ"
              created_by={created_by}
              created_date={created_date}
              documentType="manufacture_order"
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ManufactureESignatureFooter;
